import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../common/FormUtils';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../common/FormModal';
import CandidateService from './CandidateService';

import schema from './candidateJsonSchema';
const jsonSchema = schema;

const CandidateForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    if (undefined !== identifier) {
      CandidateService.retrieveCandidate(identifier)
        .then(data => {
          setData(data);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);
  const handleCandidateFormSubmit = formData => {
    CandidateService.saveCandidate(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Candidate',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Candidate');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Create Candidate',
    ' ',
    []
  );

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Candidate  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/roles/candidates"
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleCandidateFormSubmit}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default CandidateForm;
